import {
  GET_DELIVERIES_SUCCESSFUL,
  GET_DELIVERIES_ERROR,
} from "../constants/DeliveriesConstants";

const INITIAL_STATE = {
  deliveries: {},
  loading: true,
};
const deliveriesReducer = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case GET_DELIVERIES_SUCCESSFUL:
      return {
        ...state,
        deliveries: action.payload,
        loading: false,
      };
    case GET_DELIVERIES_ERROR:
      return Object.assign({}, state, { error: action.payload });
    default:
      return state;
  }
};

export default deliveriesReducer;
